import useOrganizations from './useOrganizations';

const useOrganizationById = (organizationId?: number | null) => {
  const organizations = useOrganizations();
  return organizations.find(organization => organization.id === organizationId);
};

export default useOrganizationById;
